import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../contexts/auth/Context";
import { getPaymentMethodsRequest } from "../requests/paymentMethod";
import type { PaymentMethodResponse } from "../requests/paymentMethod";
import { CACHE_TIMES } from "../../query/options";

export const PAYMENT_METHODS_QUERY_KEY = ["paymentMethods"] as const;

export const usePaymentMethods = () => {
  const { token } = useAuth();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: PAYMENT_METHODS_QUERY_KEY,
    queryFn: (): Promise<PaymentMethodResponse[]> => {
      if (!token) throw new Error("Token is required");
      return getPaymentMethodsRequest(token);
    },
    enabled: Boolean(token),
    ...CACHE_TIMES.STATIC_DATA,
  });

  return {
    data,
    isLoading,
    error,
    refetch,
  };
};
